import { AxisLeftTick } from '../../scorecard-mi2/chart/axis-left-tick';
export function getLeftTicks(): AxisLeftTick[] {
    let tickCount = 0;
    const tickStep = 1;
    const maxTickId = 10;
    const tickColor = '#000';

    const leftTicks = [];

    for (tickCount = 0; tickCount <= maxTickId; tickCount += tickStep) {
        leftTicks.push({
            tickId: tickCount,
            color: tickColor,
            label: (tickCount * 10).toString(),
            isExtentTick: true,
        });
    }
    return leftTicks;
}
